<template>
  <div class="chapterOne">
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">第2章 AI问题求解（5 用AI解决问题）</div>
      <div style="marginTop:30px;fontSize:12px;color:rgb(153,153,153);">2020-3-14 20:12:32</div>
      <div class="text fontBig" style="marginTop:70px;">搜索算法不一定是一种很酷的AI方法，但它们可以被用来解决我们大多数人都承认需要智能的任务，比如导航或下棋。</div>
      <div class="text fontBig">在第2章，我们将介绍以下几个部分。</div>
      <div class="fontBig" style="color:#0090ff;cursor: pointer;" @click="jumpOne">一、<span style="color:#0090ff;textDecoration:underline;">搜索和问题求解</span>（0/2）</div>
      <div class="fontBig" style="color:#0090ff;cursor: pointer;"  @click="jumpTow">二、<span style="color:#0090ff;textDecoration:underline;">用AI解决问题</span>（---）</div>
      <div class="fontBig" style="color:#0090ff;cursor: pointer;" @click="jumpThree">三、<span style="color:#0090ff;textDecoration:underline;">搜索和游戏</span>（0/1）</div>
      <div  id="productId"><div style="marginTop:50px;fontSize:22px;fontWeight:bold;">第2节 用AI解决问题</div></div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">一、人工智能历史的插曲：从搜索开始</div>
      <div class="text fontBig">人工智能可以说与计算机科学一样古老。早在我们拥有计算机之前，人们就想到了自动推理和智能的可能性。正如我们在第一章中已经提到的，考虑到这个问题的伟大思想家之一是阿兰·图灵。除了图灵测试之外，他对AI的贡献，以及对计算机科学更广泛的贡献，包括他对任何可以计算的东西（使用数字或其他符号计算）都可以自动化的见解。</div>
      <div class="text fontBig" style="color:#f15a23;"><b>1. AI帮助赢得二战</b></div>
      <div class="text fontBig" style="color:#f15a23;">图灵设计了一种非常简单的设备，可以计算任何可计算的东西。他的设备被称为图灵机。尽管这是一种理论模型，实际上并不实用，导致图灵发明了可编程计算机：根据编程内容可以用来执行不同任务的机器。</div>
      <div class="text fontBig" style="color:#f15a23;">因此，我们不必为每个任务构建不同的设备，而是将同一台计算机用于许多任务，这就是编程的思想。如今，这项发明听起来微不足道，但在图灵时代，却远非如此。第二次世界大战期间，一些早期的可编程计算机被用于破解德国密码，图灵也亲自参与了这个项目。</div>
      <div class="text fontBig">AI一词通常归因于约翰·麦卡锡（John McCarthy，1927-2011年），他也被称为AI之父，但实际上，他否认提出这个词。尽管如此，他还是对这一新兴领域的名称产生了影响。AI名称是在一次暑期研讨会上被确立，这次研讨会被称为达特茅斯会议，由麦卡锡于1956年在新罕布什尔州的达特茅斯学院组织举行。在组织研讨会的建议中，麦卡锡继续了图灵关于自动计算的观点。</div>
      <div class="text fontBig">可见，图灵和麦卡锡都可称为AI的开创者。</div>
      <div class="text fontBig" style="color:#f15a23;"><b>2. AI的关键声明</b></div>
      <div class="text fontBig" style="color:#f15a23;">1956年的达特茅斯会议是AI的历史转折点。在这次会议上，约翰·麦卡锡主导发表了关于AI的声明： “这项研究是基于这样的猜想，即学习的每个方面或智能的任何其他特征，原则上都可以被精确地描述，从而可以制造出机器来进行模拟。”</div>
      <div class="text fontBig">换句话说，智能的任何要素都可以分解为小的单因素，每个小因素又是如此简单和“机械”，以至于可以写成一个计算机程序。这个说法曾经是，现在仍然是一个猜想，这意味着我们无法真正证明它是真的。尽管如此，当谈到我们思考AI的方式时，这个说法绝对是基本不变的思想。例如，它表明麦卡锡想以塞尔（Searle）中文房间的精神绕开任何争论：智能就是智能，即使实现智能的系统仅仅是一台机械地遵循程序的计算机。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">二、为何搜索和游戏成为AI研究的中心</div>
      <div class="text fontBig">在1950年代及以后，随着计算机的发展，AI开始从理论进入实用水平阶段，最显著的AI问题（除了破解纳粹密码）就是游戏。游戏提供了一个方便的受限领域，可以很轻松地将其形式化。诸如跳棋、国际象棋，以及最近非常著名的围棋（一种至少在2500年前起源于中国的极其复杂的战略游戏），之类的的棋盘游戏，已经激发了无数研究人员的灵感，并将继续这样进行下去。</div>
      <div class="text fontBig">与游戏密切相关的搜索和规划技术，是AI在1960年代取得巨大进步的一个领域。那个时代开发的Minimax算法，以及由此发展起来的诸如Alpha-Beta Pruning之类名称的算法，仍是AI游戏开发的基础。当然，多年来的不断发展已经提出了更高级的新版本。在本章下一节中，我们将从概念上进一步研究游戏和规划问题。</div>
      <div class="backBtn" style="margin:20px auto;textAlign:center;">
        <button @click="goBlank" style="cursor: pointer;">上一页</button>
        <button @click="goMune"  style="marginLeft:15px;marginRight:15px;cursor: pointer;">返回目录页</button>
        <button @click="NextClk" style="cursor: pointer;">下一页</button>
      </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods:{
    jumpOne(){
      this.$router.push('/chapterFour');
    },
    jumpTow(){
      const returnEle = document.querySelector("#productId");  //productId是将要跳转区域的id
        if (!!returnEle) {
          returnEle.scrollIntoView(true); // true 是默认的
        }
        document.querySelector("counter1").scrollIntoView(true); //这里的counter1是将要返回地方的id
    },
    jumpThree(){
      this.$router.push('/chapterSix');
    },
    goBlank(){
      this.$router.push('/chapterFour');
    },
    goMune(){
      this.$router.push('/');
    },
    NextClk(){
      this.$router.push('/chapterSix');
    },
    
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.chapterOne{
    width: 650px;
    margin: 0 auto;
    padding: 0px 75px;
}
.text{
    text-indent:2em;
}
.fontBig{
    font-size: 16px;
    color: rgb(102, 102, 102);
    line-height: 30px;
    
}
.sentBtn{
  width: 100px;
  margin-left: 240px;
  margin-top: 25px;
  margin-bottom: 25px;
  cursor: pointer;
}
.anwser{
  width: 200px;
  height: 200px;
  border: 1px dashed black;
  margin-left: 230px;
  overflow:auto;
  font-size: 14px;
  outline: none;
  margin-top: 10px;
  padding: 10px;
}
.anwserInput{
  border: none;
  outline: none;
  border-bottom: 1px solid;
  font-size:16px;
}
.backBtn button{
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/chapterFive.vue